import { Flex, Skeleton } from "antd";
import { useMyContext } from "../../../../entities/context";
import { DividerThin } from "../../../../shared";
import { ReactComponent as More } from '../../../../assets/images/icon/more.svg'
import '../../index.css'

const CommunityDetailSkeleton = () => {
    const { topHeight } = useMyContext();

    return <div style={{ paddingTop: (topHeight + 'px'), position: 'fixed', zIndex: 3, backgroundColor: 'white', maxHeight: '100vh', height: '100vh', width: '100vw', overflowY: 'hidden' }}>
        <div style={{ paddingBlock: '13px 17px', textAlign: 'center' }}>
            <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '22px', width: '215px' }} />
        </div>

        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
                <More fill="var(--secondarys400)" />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ marginBottom: '12px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '222px', width: '100%' }} />
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '6px', marginBottom: '24px' }} />

        <div style={{ paddingInline: '20px' }}>
            <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '20px', width: '180px' }} />
        </div>

        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
                <More fill="var(--secondarys400)" />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '20px', width: '200px' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '1px' }} />

        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
                <More fill="var(--secondarys400)" />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '20px', width: '200px' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '1px' }} />

        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '17px', width: '180px' }} />
                <More fill="var(--secondarys400)" />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '20px', width: '200px' }} />
            </div>
            <div style={{ marginBottom: '8px' }}>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '24px', width: '100%' }} />
            </div>
            <div>
                <Skeleton.Node className="custom-skeleton" active={true} style={{ height: '18px', width: '40px' }} />
            </div>
        </div>

        <DividerThin style={{ height: '1px' }} />

    </div>
}

export default CommunityDetailSkeleton;